import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { DecimalConfig } from './../configs/decimal.config';

//

@Pipe({
  name: 'lumCurrency',
})
export class LumCurrencyPipe implements PipeTransform {
  constructor(private currencyPipe :CurrencyPipe) {}

  transform(
    value :any,
    currencyCode = 'USD',
    symbolDisplay = 'symbol',
    digitsInfo = `1.0-${DecimalConfig.defaultPlaces}`,
  ) :string | null {
    // Use Angular's CurrencyPipe with a default digitsInfo
    return this.currencyPipe.transform(
      value,
      currencyCode,
      symbolDisplay,
      digitsInfo,
    );
  }
}

@Pipe({
  name: 'lumCurrency',
  standalone: true,
})
export class LumCurrencyStandalonePipe
  extends LumCurrencyPipe
  implements PipeTransform {}
